export var BonusCreditType;
(function (BonusCreditType) {
    BonusCreditType["Hubspot"] = "hubspot";
})(BonusCreditType || (BonusCreditType = {}));
//# sourceMappingURL=bonusCreditType.js.map